module.exports = __webpack_public_path__ + "static/img/bg_coupon_five_grey_out.952d875.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_five_grey_out.png
// module id = SWgx
// module chunks = 0